import React from 'react';
import styles from './ChatMessage.module.scss';
import { ChatRole } from '../../../../../../../types/ChatRoles';
import { useAppSelector } from '../../../../../../../store/hooks';

interface ThinkingMessageProps {
  lastUserMessageSequence: number;
}

const ThinkingMessage: React.FC<ThinkingMessageProps> = ({ lastUserMessageSequence }) => {
  const thinkingMessage = useAppSelector((state) => state.chat.thinkingMessage);

  const showThinkingUpdate =
    thinkingMessage &&
    thinkingMessage.thinkingStatus !== '' &&
    thinkingMessage.sequence === lastUserMessageSequence;

  const contentClass = `${styles.messageContent} ${styles.thinkingMessage}`;

  return (
    <div className={`${styles.messageRow} ${styles[ChatRole.Assistant]}`}>
      <div className={styles.messageContainer}>
        <div className={contentClass}>
          <div className={styles.messageText}>
            <div className={styles.typingIndicator}>
              {showThinkingUpdate ? thinkingMessage.thinkingStatus : 'Thinking'}
              <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThinkingMessage;
